import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';

import { MenuContentItem, UserService } from '@frontend/vanilla/core';
import { AccountMenuConfig } from '@frontend/vanilla/shared/account-menu';
import { TrustAsHtmlPipe } from '@frontend/vanilla/shared/browser';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { capitalize } from 'lodash-es';
import { Subject, filter, takeUntil } from 'rxjs';

import { AccountMenuItemBase } from '../account-menu-item-base';
import { MLifeProfile } from '../account-menu.models';
import { MLifeRewardsProfile } from './mlife-rewards.component';

@Component({
    standalone: true,
    selector: 'vn-user',
    imports: [CommonModule, IconCustomComponent, TrustAsHtmlPipe],
    templateUrl: './user.component.html',
})
export class UserComponent extends AccountMenuItemBase implements OnInit {
    mlife: MLifeRewardsProfile;
    useV2: boolean;
    accountMenuVersion: number;
    inboxItem: MenuContentItem;
    unsubscribe = new Subject<void>();
    user = inject(UserService);
    accountMenuConfig = inject(AccountMenuConfig);

    ngOnInit(): void {
        this.accountMenuVersion = this.accountMenuService.version;

        this.accountMenuService.mLifeProfileEvents
            .pipe(
                filter((d: MLifeProfile | null): d is MLifeProfile => d != null),
                takeUntil(this.unsubscribe),
            )
            .subscribe((data: MLifeProfile) => {
                const resources = this.accountMenuVersion === 1 ? this.accountMenuService.resources.messages : this.item.resources;
                this.mlife = {
                    userGreeting: resources.UserGreeting?.replace('{NAME}', capitalize(this.user.firstName ?? '')) ?? '',
                    fullNameLower: `${this.user.firstName} ${this.user.lastName}`.toLowerCase(),
                    tierNumberText: this.accountMenuVersion === 4 ? resources.MLifeNumberText || '' : '',
                    tierNumber: data.mlifeNo,
                    tierDescription: data.tierDesc,
                    viewDetailsText: this.item.text,
                    tierCredits: resources.MLifeCredits?.replace('{CREDITS}', data.tierCredits.toString()) || '',
                    fullName: `${this.user.firstName} ${this.user.lastName}`,
                };
            });
        this.accountMenuService.updateMLifeProfile();
    }
}
